export const SubFeatureHooksFromDefaultHooks = (
  source,
  prefix: "HookForm" | "HookField",
  subFeature
) => {
  return Object.keys(source).reduce((val, k) => {
    val[`${prefix}${subFeature}${k.replace(prefix, "")}`] = source[k]
    return val
  }, {})
}
